import type { Event } from '../types';

export const YearInReviewEventData = {
  YIRPageViewed: {
    eventAction: 'YIRPageViewed',
  } as Event<string>,
  YIRPageGoBack: {
    eventAction: 'YIRPageGoBack',
  } as Event<string>,
  YIRPageGoNext: {
    eventAction: 'YIRPageGoNext',
  } as Event<string>,
  YIRPageShare: {
    eventAction: 'YIRPageShare',
  } as Event<string>,
  YIREntered: {
    eventAction: 'YIREntered',
  } as Event<string>,
  YIRError: {
    eventAction: 'YIRError',
  } as Event<string>,
};
